export const environment = {
  production: true,
  defaultTimezone: '+0500',
  apiUrl: 'https://api.equrylys.kz',
  apiUrl2: 'https://api.equrylys.kz/api',
  khcUrl: 'https://khc.m11s.equrylys.kz',
};
